import { useGetClientInstrumentsData } from './hooks/useGetClientInstrumentsData';
import { useGetTransactionInitialData } from './hooks/useGetTransactionInitialData';

export enum BLACKLIST_CARD_MASK_DATA_VARIANT {
  CLIENT_INSTRUMENTS_DATA = 'clientInstrumentsData',
  TRANSACTION_DATA = 'transactionData',
}

export const initialDataHook = {
  [BLACKLIST_CARD_MASK_DATA_VARIANT.CLIENT_INSTRUMENTS_DATA]: useGetClientInstrumentsData,
  [BLACKLIST_CARD_MASK_DATA_VARIANT.TRANSACTION_DATA]: useGetTransactionInitialData,
};

export const defaultValues = {
  bin: '',
  blockFullOrganization: true,
  customerId: null,
  lastFour: null,
  merchantId: null,
};
